import { useQuery } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { NOMINATIM_URL } from '@/features/geo-coding/constants/geoCoding';
import type { OsmPlace } from '@/features/geo-coding/types/place';
import { isEmptyOrNull } from '@/shared/utils/string';

export const useSearch = (query?: string) =>
  useQuery({
    queryKey: [API_CACHE_KEYS.GEOCODE_SEARCH, { query }],
    queryFn: async () => await fetchSearch(query!),
    enabled: !isEmptyOrNull(query) && query.length >= 3
  });

async function fetchSearch(query: string): Promise<OsmPlace[]> {
  const url =
    NOMINATIM_URL +
    'search?q=' +
    encodeURIComponent(query) +
    '&addressdetails=1&format=json&accept-language=de&limit=10';

  const response = await fetch(url);

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  return response.json() as Promise<OsmPlace[]>;
}
